import { render, staticRenderFns } from "./AudioGuideButton.vue?vue&type=template&id=30b1155e&"
import script from "./AudioGuideButton.vue?vue&type=script&lang=ts&"
export * from "./AudioGuideButton.vue?vue&type=script&lang=ts&"
import style0 from "./AudioGuideButton.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports